<template>
  <div class="m-4 overflow-auto">
    <div class="d-flex flex-row align-items-center mb-4">
      <div
        style="width: 408px"
        class="d-flex justify-content-between align-items-center"
      >
        <h5 class="mb-0">Patient Menu Structure</h5>
        <a
          class="mr-2 hover-pointer"
          variant="outline-primary"
          style="font-size: 14px;"
          size="sm"
          @click="addClientFolder({ parentId: rootId })"
        >
          <i class="fas fa-plus mr-1"></i>Add Folder
        </a>
      </div>
      <div class="text-center" style="width: calc(100% - 408px)">
        <h5 class="mb-0">Root Menu Items</h5>
      </div>
    </div>
    <div>
      <div class="d-flex flex-row justify-content-between align-items-start">
        <div
          style="min-width: 400px; max-width: 400px;"
          class="column-container"
        >
          <ul class="folder-tree">
            <eoc-sidebar-folder-crud-item
              v-for="(item, index) in tree"
              :key="item.item.id"
              :item="item"
              :last="index == tree.length - 1"
              @add-item="addClientFolder($event)"
              @edit-item="editClientFolder($event)"
              @delete-item="deleteClientFolder($event)"
              @reload="reload"
            />
          </ul>
        </div>
        <drop
          v-if="unAssignedItems.length == 0"
          style="width: 100%; height:500px"
          class="drop un-assigned-items  border-bottom"
          :class="
            overElement == rootId
              ? 'text-success border-success'
              : 'border-white'
          "
          @drop="handleDrop(rootId, null, true, ...arguments)"
          @dragover="handleDragOver(...arguments, rootId)"
          @dragleave="handleDragLeave(rootId)"
        />
        <div v-else class="un-assigned-items column-container">
          <div
            class="un-assigned-item"
            v-for="(elem, index) in unAssignedItems"
            :key="elem.objectId"
          >
            <drop
              style="height: 5px"
              class="drop list  border-bottom"
              :class="
                overElement == elem.id
                  ? 'text-success border-success'
                  : 'border-white'
              "
              @drop="handleDrop(elem.menuId, elem.id, true, ...arguments)"
              @dragover="handleDragOver(...arguments, elem.id)"
              @dragleave="handleDragLeave(elem.id)"
            >
            </drop>
            <drag class="drag" :transfer-data="{ item: elem, isForm: true }">
              <span class="pr-2" style="color: lightgray">
                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
              </span>
              <i class="fa fa-file-text mr-2"></i>
              <span class="font-weight-light">{{ elem.name }} </span>
            </drag>
            <drop
              v-if="index == unAssignedItems.length - 1"
              style="height: 5px"
              class="drop list  border-bottom"
              :class="
                overElement == elem.id
                  ? 'text-success border-success'
                  : 'border-white'
              "
              @drop="handleDrop(elem.menuId, elem.id, false, ...arguments)"
              @dragover="handleDragOver(...arguments, elem.id)"
              @dragleave="handleDragLeave(elem.id)"
            >
            </drop>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      centered
      ref="form-modal"
      :title="formId ? 'Edit Patient Folder' : 'Add Patient Folder'"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submitClientFolder"
      no-close-on-backdrop
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <b-form-group label="Name">
        <b-form-input placeholder="" v-model="form.name" trim></b-form-input>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import patientFolderServer from "../../server/menu";
import EocSidebarFolderCrudItem from "./EocSidebarFolderCrudItem.vue";
import { mapActions } from "vuex";

export default {
  name: "EocSidebarFolderCrud",
  components: { EocSidebarFolderCrudItem },
  data() {
    return {
      list: [],
      formId: null,
      form: {
        name: "",
        items: [],
        parentId: null
      },
      overElement: null
    };
  },
  mounted() {
    this.getClientFolders();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    async getClientFolders() {
      this.list = await patientFolderServer.query();
    },
    async submitClientFolder() {
      const formData = {
        name: this.form.name,
        items: this.form.items,
        parentId: this.form.parentId
      };
      if (this.formId) {
        await patientFolderServer.update(this.formId, formData);
      } else {
        await patientFolderServer.create(formData);
      }
      this.getClientFolders();
      this.showAlertSuccess();
    },
    addClientFolder({ parentId }) {
      this.formId = null;
      this.form = {
        name: "",
        items: [],
        parentId: parentId
      };
      this.$refs["form-modal"].show();
    },
    editClientFolder({ data }) {
      this.formId = data.id;
      this.form = {
        name: data.name,
        items: data.items,
        parentId: data.parentId
      };
      this.$refs["form-modal"].show();
    },
    deleteClientFolder({ id }) {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to delete this record?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(async () => {
          await this.restoreToFullRootPosition(id);
          await patientFolderServer.delete(id);
          this.getClientFolders();
          this.showAlertSuccess();
        })
        .catch(function() {});
    },
    buildTree(list, rootId) {
      let tree = [];
      for (let index = 0; index < list.length; index++) {
        const item = list[index];
        if (item.parentId == rootId) {
          let treeItem = {
            item: item,
            subItems: this.buildTree(list, item.id)
          };
          tree.push(treeItem);
        }
      }
      return tree;
    },
    reload() {
      this.getClientFolders();
      this.showAlertSuccess();
    },
    async handleDrop(menuId, menuItemId, above, data) {
      this.overElement = null;
      if (data.isForm) {
        await patientFolderServer.moveMenuItem({
          menuItem: data.item,
          menuId: menuId,
          menuItemId: menuItemId,
          above: above
        });
      }
      this.getClientFolders();
    },
    handleDragOver(data, event, elemId) {
      if (!data.isForm) {
        event.dataTransfer.dropEffect = "none";
        this.overElement = null;
      } else {
        this.overElement = elemId;
      }
    },
    handleDragLeave() {
      this.overElement = null;
    },
    async restoreToFullRootPosition(id) {
      const rootId = this.rootId;

      const moveItems = async arr => {
        for (let index = 0; index < Object.keys(arr).length; index++) {
          const element = Object.keys(arr)[index];

          if (typeof arr[element] === "object") {
            if (arr[element].type === "Form") {
              await patientFolderServer.moveMenuItem({
                above: true,
                menuId: rootId,
                menuItem: {
                  id: arr[element].id,
                  name: arr[element].name,
                  objectId: arr[element].objectId,
                  position: 0,
                  type: "Form",
                  menu: arr[element].menu,
                  menuId: arr[element].menuId
                },
                menuItemId: null
              });
            }
            await moveItems(arr[element]);
          }
        }
      };
      await moveItems(this.findById(this.tree, id));
    },
    findById(tree, nodeId) {
      for (let node of tree) {
        if (node.item.id === nodeId) return node;

        if (node.subItems) {
          let desiredNode = this.findById(node.subItems, nodeId);
          if (desiredNode) return desiredNode;
        }
      }
      return false;
    }
  },
  computed: {
    tree() {
      return this.buildTree(this.list, this.rootId);
    },
    rootId() {
      const root = this.list.find(u => u.parentId == null);
      return root ? root.id : null;
    },
    unAssignedItems() {
      return this.list.find(u => u.parentId == null)
        ? this.list.find(u => u.parentId == null).items
        : [];
    }
  }
};
</script>

<style scoped>
.column-container {
  max-height: calc(100vh - 267px);
  overflow-y: auto;
}
</style>
<style lang="scss">
.folder-tree {
  background-color: white;
  padding: 15px 20px 5px 30px;
  list-style-type: none;
  font-size: 14px;
}

.un-assigned-items {
  font-size: 14px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .drag {
    background-color: white;
    padding: 5px 10px;
  }

  .un-assigned-item {
    width: 33.33%;
    box-sizing: border-box;
    background-clip: content-box;
    padding: 0px 10px;
  }
}
</style>
